/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text → Morse`)
};

const es_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto → Morse`)
};

const de_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text → Morse`)
};

const nl_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst → Morse`)
};

const fr_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text → Morse`)
};

const it_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text → Morse`)
};

const pt_br2_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto → Morse`)
};

const pt_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto → Morse`)
};

const ja_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト → モールス`)
};

const zh_mc_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text → Morse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_mode_encode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_mode_encode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_mode_encode", locale)
	if (locale === "en") return en_mc_mode_encode(inputs)
	if (locale === "es") return es_mc_mode_encode(inputs)
	if (locale === "de") return de_mc_mode_encode(inputs)
	if (locale === "nl") return nl_mc_mode_encode(inputs)
	if (locale === "fr") return fr_mc_mode_encode(inputs)
	if (locale === "it") return it_mc_mode_encode(inputs)
	if (locale === "pt-BR") return pt_br2_mc_mode_encode(inputs)
	if (locale === "pt") return pt_mc_mode_encode(inputs)
	if (locale === "ja") return ja_mc_mode_encode(inputs)
	return zh_mc_mode_encode(inputs)
};